export const philippineCities = [
  { name: "Manila", lat: 14.5995, lng: 120.9842, population: 1780000 },
  { name: "Quezon City", lat: 14.6760, lng: 121.0437, population: 2936116 },
  { name: "Davao City", lat: 7.1907, lng: 125.4553, population: 1776949 },
  { name: "Cebu City", lat: 10.3157, lng: 123.8854, population: 964169 },
  { name: "Zamboanga City", lat: 6.9214, lng: 122.0790, population: 977234 },
  { name: "Cagayan de Oro", lat: 8.4542, lng: 124.6319, population: 728402 },
  { name: "General Santos", lat: 6.1164, lng: 125.1716, population: 697315 },
  { name: "Baguio City", lat: 16.4023, lng: 120.5960, population: 366358 },
  { name: "Iloilo City", lat: 10.7202, lng: 122.5621, population: 457626 },
  { name: "Bacolod City", lat: 10.6770, lng: 122.9515, population: 600783 },
  { name: "Iligan City", lat: 8.2280, lng: 124.2452, population: 342618 },
  { name: "Butuan City", lat: 8.9470, lng: 125.5406, population: 372910 },
  { name: "Tacloban City", lat: 11.2448, lng: 125.0047, population: 251881 },
  { name: "Naga City", lat: 13.6218, lng: 123.1948, population: 209170 },
  { name: "Legazpi City", lat: 13.1391, lng: 123.7445, population: 209533 },
  { name: "Tuguegarao City", lat: 17.6132, lng: 121.7270, population: 166334 },
  { name: "Puerto Princesa", lat: 9.7392, lng: 118.7353, population: 307079 },
  { name: "Pagadian City", lat: 7.8308, lng: 123.4367, population: 210452 },
  { name: "Cotabato City", lat: 7.2231, lng: 124.2467, population: 325079 },
  { name: "Dumaguete City", lat: 9.3067, lng: 123.3067, population: 134103 },
  { name: "Dipolog City", lat: 8.5958, lng: 123.3411, population: 130759 },
  { name: "Ormoc City", lat: 11.0059, lng: 124.6072, population: 230998 },
  { name: "Tagbilaran City", lat: 9.6496, lng: 123.8664, population: 104976 },
  { name: "Surigao City", lat: 9.7840, lng: 125.4969, population: 171107 },
  { name: "Malaybalay City", lat: 8.1531, lng: 125.1276, population: 190712 }
];

export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export function findNearestCity(lat, lng) {
  let nearest = null;
  let minDistance = Infinity;

  philippineCities.forEach(city => {
    const distance = calculateDistance(lat, lng, city.lat, city.lng);
    if (distance < minDistance && distance <= 250) {
      minDistance = distance;
      nearest = { ...city, distance_km: Math.round(distance) };
    }
  });

  return nearest;
}